module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uwEUZwWbLNoTeHqth7GjNR3"
    }
  }, [_vm._v("Chapter Four")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("For Marian Dougherty, Wednesday, June 4 was a special day. Not only was it her fifteenth birthday, but it was also the day she had promised she would try the new wonder drug with her main squeeze, Manuel Ortiz, the leader of a street gang known as the ‘Tiburones’.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("It was ten o’clock in the morning. Marian and her two friends, Donna and Carmelita, were standing on Coney Island’s boardwalk clustered outside the Wonder Wheel’s ticket booth waiting for the ride to open. It appeared that Manny was a “no-show”. Could it be he was all talk and no go?")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Marian, you got dissed,” said Carmelita, hands on hips.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Dissed . . .  dissed . . .  dissed,” Donna echoed.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“No, I didn’t,” the birthday girl gloated as her young Romeo in Nike T-shirt and Hilfiger jeans climbed the steps of the boardwalk and strutted toward them.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Marian shuddered in anticipation, having looked forward to this monumental step just as much as she feared it. But all her friends had already done the dope and she didn’t want to feel like a wimp.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Yo! I’m a walkin’ birthday present,” Manuel boasted, sidling up next to the girls.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Your little honey’s afraid o’ heights, Manuel. You gonna cure her?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“She’s in for a double dose of magic, Carmelita. She’s with the head of the Tiburones.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The teens watched as the machinist opened the gates allowing entrance to the giant Ferris wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“We’re in the red one!” Marian hollered, rushing toward the empty cage, hoping her excitement didn’t make her look like a kid.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Yo, man! Today she learns how to fly,” said Manuel to the ride’s engineer. “This here’s a twenty. That should cover us all. And here’s an extra ten-spot, just for you. Make sure that red cage stays on top for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“You got it,” the handler said, sliding the cash into his jeans.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Marian, we’ll be right behind you. If you freeze and you wanna spit it out, don’t let him see ya’ do it.” Carmelita smiled, mouthed a ‘Happy Birthday’ before joining Donna inside their own painted cage.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Yo! Let’s get this thing off the ground!” hollered Manuel, climbing in next to his darling.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Gears engaged and metal whined as the giant Ferris wheel lifted the fun seekers into the air.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“So? You ready or what?” asked Manuel.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Marian looked around. Her friends were in the cage behind them. “Ready!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Here, it comes with a gift,” said Manuel.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Wow!” she said, putting on the earrings.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“They ain’t no real diamonds. But they’re real crystal. Just like this.” He produced the packet of meth capsules.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Bein’ way up top’s gonna add to the rush.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Marian clenched the mini-Ziploc in her fist.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Being on top with you is rush enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Howling like an arctic wolf, Manuel wrapped his arm around his birthday girl and stared skyward.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v(" “Ready or not, here we come!” Marian hollered, then wished she hadn’t. I’m not a kid! Not no more! I’m gonna fly! I’m gonna fly! she heard an unconvincing internal voice cry out.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The cage stopped, having reached its zenith. No one had come for the view.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Marian turned her head. Panic seized her. “Let’s go back down,” she whimpered.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Why? We just got here!”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“There’s someone looking at us in the next cage!”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“What? Didya’ take somethin’ before we got on? That’s Carmelita and Donna!” pointing to the two wide-eyed teens in the cage behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“No!” Marian shouted. “The "), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("next")]), _vm._v(" car!”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("In the cage behind their friends, a man sat like a propped-up marionette. There was a large gash on the side of his ashen face and red stains on his tee-shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Hey, you! Get us down!” screamed Manuel.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“What’s he doing?” stammered Marian, eyes fixed on the unexpected visitor.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“He ain’t doin’ nothin’. I think he’s dead.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4afb1254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/SR_004.vue
// module id = 87
// module chunks = 0